import { render } from "./CollectionContentCampaign.vue?vue&type=template&id=a24a1f4c"
import script from "./CollectionContentCampaign.vue?vue&type=script&lang=js"
export * from "./CollectionContentCampaign.vue?vue&type=script&lang=js"

import "./CollectionContentCampaign.vue?vue&type=style&index=0&id=a24a1f4c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__